export const TOLLDOMAIN_NAME_MAX_LENGTH = 30;
export const TOLLDOMAIN_NAME_FORBIDDEN_REGEXP = '^[a-zA-ZÀ-ȕ0-9_-]+(\\s+[a-zA-ZÀ-ȕ0-9_-]+)*$';
export const TOLLDOMAIN_DESCRIPTION_MAX_LENGTH = 300;
export const TOLLDOMAIN_DESCRIPTION_FORBIDDEN_REGEXP = '^[a-zA-ZÀ-ȕ0-9_-]*(\\s+[a-zA-ZÀ-ȕ0-9_-]*)*$';
export const TOLLDOMAIN_CODE_MAX_LENGTH = 2;
export const TOLLDOMAIN_TSP_MAX_LENGTH = 20;
export const TOLLDOMAIN_CODE_FORBIDDEN_REGEXP = '^[a-zA-Z]*$';
export const TOLLDOMAIN_TSP_FORBIDDEN_REGEXP = '^[A-Za-z;,-_]*( ?[A-Za-z;,-_] ?)*$';
export default TOLLDOMAIN_NAME_MAX_LENGTH;
export const TOLLDOMAIN_TYPES = ['default', 'test', 'official'];
